import validatejs from "validate.js";
import Strings from "../translations/translations";
import XRegExp from "xregexp";

validatejs.validators.sponsorship = function (value, options, key, attributes) {
  return /\d{6}/.test(value) || !value.length ? null : options.message;
};

const validation = {
  email: {
    presence: {
      allowEmpty: false,
      message: "^error_email_presence",
    },
    email: {
      message: "^error_email_email",
    },
  },

  password: {
    presence: {
      allowEmpty: false,
      message: "^error_password_presence",
    },
    format: {
      pattern: "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9@#$%^&+*!=]).*$",
      message: "^error_password_format",
    },
    length: {
      minimum: 8,
      message: "^error_password_length",
    },
  },

  passwordLength: {
    length: {
      minimum: 8,
      message: "^error_password_length",
    },
  },
  passwordMin: {
    format: {
      pattern: "(?=.*[a-z]).*$",
    },
  },
  passwordMaj: {
    format: {
      pattern: "(?=.*[A-Z]).*$",
    },
  },
  passwordSpecial: {
    format: {
      pattern: "(?=.*[0-9@#$%^&+*!=]).*$",
    },
  },

  lastname: {
    presence: {
      allowEmpty: false,
      message: "^error_lastname_presence",
    },
    format: {
      pattern: XRegExp("^[\\pL-' ]+$"),
      message: "^error_lastname_format",
    },
    length: {
      maximum: 40,
      minimum: 1,
      message: "^error_lastname_length",
    },
  },

  firstname: {
    presence: {
      allowEmpty: false,
      message: "^error_firstname_presence",
    },
    format: {
      pattern: XRegExp("^[\\pL-' ]+$"),
      message: "^error_firstname_format",
    },
    length: {
      maximum: 40,
      minimum: 1,
      message: "^error_firstname_length",
    },
  },

  sponsorship: {
    sponsorship: {
      message: "^error_sponsorship_length",
    },
  },

  phone: {
    length: {
      maximum: 10,
      minimum: 9,
      message: "^error_invalid_number",
    },
    numericality: {
      onlyInteger: true,
      message: "^error_invalid_number",
    },
  },
  addressPhone: {
    presence: {
      allowEmpty: false,
      message: "^error_address_phonenumber_presence",
    },
    length: {
      maximum: 10,
      minimum: 9,
      message: "^error_address_number",
    },
    numericality: {
      onlyInteger: true,
      message: "^error_address_number",
    },
  },

  required: {
    presence: {
      allowEmpty: false,
      message: `^field_required`,
    },
  },

  isChecked: {
    equality: {
      attribute: "true",
      comparator: (v1, v2) => {
        return v1 === true;
      },
      message: `^field_required`,
    },
  },
};

/**
 * Valider un champ input
 * @param {string} fieldName Le type de champ
 * @param {any} value Valeur du champ
 */
export default function Validate(fieldName, value) {
  // Validate.js validates your values as an object
  // e.g. var formValues = {email: 'email@example.com'}
  var formValues = {};
  formValues[fieldName] = value;

  // Creates a temporary form with the validation fields
  var formFields = {};
  formFields[fieldName] = validation[fieldName];

  // The formValues and validated against the formFields
  // the variable result hold the error messages of the field
  const result = validatejs(formValues, formFields);

  // If there is an error message, return it!
  if (result) {
    // Return only the field error message if there are multiple
    return result[fieldName][0];
  }

  return null;
}
